export default __webpack_public_path__ + "static/media/SplashImagePrelaunch.1f995f9b.svg";